













































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import SwapListingTrigger from './SwapListingTrigger.coffee'

settings =
  name: 'SwapListingTriggerModal'

  resources: 
    audience_listings:
      resourceName: 'audience_listing'
      slug: 'suppliers/:topOrg.id/audience_listings'
      fetch: false
    vendor_listings:
      resourceName: 'vendor_listing'
      slug: 'suppliers/:topOrg.id/vendor_listings'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    mixins: [SwapListingTrigger.trigger()]

    components: {
      Modal,
      RequestButton,
      LoadingIndicator,
    }

    computed:
      offer: ->
        @modal.config.offer

      topOrg: ->
        @ctxSupplierOrg @offer

      audienceListing: ->
        @ctxAudienceListing @offer

      vendorListing: ->
        @ctxVendorListing @offer

      listingType: ->
        @offer?.activation_plan.type

      spaceType: ->
        @offer?.activation_snapshot_space_types[0].split(':')[0]

      isAudienceListing: ->
        @listingType is 'audience_listing'

      isVendorListing: ->
        @listingType is 'vendor_listing'

      listingOptions: ->
        listings = @audience_listings if @isAudienceListing
        listings = @vendor_listings if @isVendorListing
        listings ||= []
        listings = listings.filter((listing) => listing.id isnt (@audienceListing.id || @vendorListing.id))
        listings.filter((listing) -> !listing.is_omnichannel)

      segmentOptions: ->
        listing = (@audience_listings || []).find((listing) => listing.id is @modal.data.new_listing_id)
        return [] unless listing
        segments = Object.values(listing.spaces).map((space) => space.segment if space.type is @spaceType)
        @compact segments

      canSubmit: ->
        { new_listing_id, new_segment } = @modal.data
        return !new_listing_id || !new_segment if @isAudienceListing
        !new_listing_id

    methods:
      modalData: ->
        new_listing_id: null
        new_segment: null

export default VueOptions.vue settings
